module.exports = __webpack_public_path__ + "static/media/delete.000298ac.svg";